import moment from 'moment';

var today = new Date();

function formatWithTime(hour) {
  return moment(
    new Date(today.getFullYear(), today.getMonth(), today.getDate(), hour, 0, 0)
  ).format('YYYY-MM-DD HH:mm:ss');
}

export const eventsDataSecond = [
  {
    id: 1,
    start: formatWithTime(9),
    end: formatWithTime(11),
    resourceId: 'r8',
    treeItemId: '202',
    title: 'L12 - BUS 102',
    bgColor: '#D9E1FF',
    hours: 2,
  },
  {
    id: 2,
    start: formatWithTime(12),
    end: formatWithTime(14),
    resourceId: 'r5',
    treeItemId: '601',
    title: 'T01 - MGT325',
    bgColor: '#C0B6F2',
    hours: 2,
  },
  {
    id: 3,
    start: formatWithTime(14),
    end: formatWithTime(15),
    resourceId: 'r8',
    treeItemId: '202',
    title: 'L12 - BUS 102',
    bgColor: '#D9E1FF',
    hours: 1,
  },
  {
    id: 4,
    start: '2022-03-09 11:00:00',
    end: '2022-03-09 13:00:00',
    resourceId: 'r8',
    treeItemId: '202',
    title: 'L12 - BUS 102',
    bgColor: '#D9E1FF',
    hours: 2,
  },
];
